/**
 * dealer-map.js — Electripet Dealer Map v4.1
 * Google Maps-style UI with Leaflet + OpenStreetMap tiles
 * Supports auto-parsing Google Maps embed iframes, share links, and raw coordinates.
 */
(function () {
  'use strict';

  /* ── 坐标解析器：支持 嵌入代码、谷歌链接、右键坐标等多种格式 ── */
  function parseCoords(str) {
    if (!str || typeof str !== 'string') return null;
    str = str.trim();
    if (!str) return null;

    // 1. 直接坐标格式：例如 "26.3774, -80.0758" 或 "26.3774,-80.0758"
    var directMatch = str.match(/^([+-]?\d+(?:\.\d+)?)[,\s\t]+([+-]?\d+(?:\.\d+)?)$/);
    if (directMatch) {
      var lat1 = parseFloat(directMatch[1]);
      var lng1 = parseFloat(directMatch[2]);
      if (lat1 >= -90 && lat1 <= 90 && lng1 >= -180 && lng1 <= 180) {
        return { lat: lat1, lng: lng1 };
      }
    }

    // 2. 谷歌地图嵌入代码 (iframe) 或 pb 参数：!2d<lng>!3d<lat>
    var lngMatch2d = str.match(/!2d(-?\d+(?:\.\d+)?)/);
    var latMatch3d = str.match(/!3d(-?\d+(?:\.\d+)?)/);
    if (latMatch3d && lngMatch2d) {
      var latEmbed = parseFloat(latMatch3d[1]);
      var lngEmbed = parseFloat(lngMatch2d[1]);
      if (latEmbed >= -90 && latEmbed <= 90 && lngEmbed >= -180 && lngEmbed <= 180) {
        return { lat: latEmbed, lng: lngEmbed };
      }
    }

    // 3. 谷歌地图标准网址：/@<lat>,<lng>,<zoom>z 或 /@<lat>,<lng>
    var atMatch = str.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (atMatch) {
      var latAt = parseFloat(atMatch[1]);
      var lngAt = parseFloat(atMatch[2]);
      if (latAt >= -90 && latAt <= 90 && lngAt >= -180 && lngAt <= 180) {
        return { lat: latAt, lng: lngAt };
      }
    }

    // 4. URL 查询参数形式：?q=<lat>,<lng> 或 &ll=<lat>,<lng> 或 ?sll=<lat>,<lng>
    var queryMatch = str.match(/[?&](?:q|ll|sll)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (queryMatch) {
      var latQ = parseFloat(queryMatch[1]);
      var lngQ = parseFloat(queryMatch[2]);
      if (latQ >= -90 && latQ <= 90 && lngQ >= -180 && lngQ <= 180) {
        return { lat: latQ, lng: lngQ };
      }
    }

    // 5. 宽松提取文本内的经纬度数字对："26.3774, -80.0758"
    var looseMatch = str.match(/(-?\d{1,2}\.\d+)[,\s]+(-?\d{1,3}\.\d+)/);
    if (looseMatch) {
      var latLoose = parseFloat(looseMatch[1]);
      var lngLoose = parseFloat(looseMatch[2]);
      if (latLoose >= -90 && latLoose <= 90 && lngLoose >= -180 && lngLoose <= 180) {
        return { lat: latLoose, lng: lngLoose };
      }
    }

    return null;
  }

  /* ── SVG pin 工厂（Google Maps 水滴形）── */
  function pinSVG(color, strokeColor) {
    return [
      '<svg viewBox="0 0 27 43" xmlns="http://www.w3.org/2000/svg">',
        '<path d="M13.5 0C6.044 0 0 6.044 0 13.5c0 9.619 13.5 29.5 13.5 29.5S27 23.119 27 13.5C27 6.044 20.956 0 13.5 0z"',
          ' fill="' + color + '" stroke="' + strokeColor + '" stroke-width="1"/>',
        '<circle cx="13.5" cy="13.5" r="5.5" fill="#fff" opacity="0.9"/>',
      '</svg>'
    ].join('');
  }

  var PIN_COLORS = {
    standard: { fill: '#EA4335', stroke: '#C5221F' },   // Google red
    gold:     { fill: '#F9A825', stroke: '#E65100' },   // gold
    active:   { fill: '#1A73E8', stroke: '#1557B0' }    // Google blue (active)
  };

  function makePinIcon(tier, state) {
    var c = state === 'active' ? PIN_COLORS.active
          : tier === 'gold'   ? PIN_COLORS.gold
          : PIN_COLORS.standard;
    var cls = 'dm-pin' + (state ? ' ' + state : '');
    return L.divIcon({
      className: '',
      html: '<div class="' + cls + '">' + pinSVG(c.fill, c.stroke) + '</div>',
      iconSize:    [27, 43],
      iconAnchor:  [13, 43],
      popupAnchor: [0, -46]
    });
  }

  function getDirectionsUrl(dealer) {
    if (dealer.lat && dealer.lng && !(dealer.lat === 0 && dealer.lng === 0)) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + dealer.lat + ',' + dealer.lng;
    }
    if (dealer.address) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dealer.address);
    }
    return 'https://www.google.com/maps';
  }

  /* ── Popup HTML ── */
  function buildPopupHTML(dealer) {
    var phone   = dealer.phone   ? '<div class="dm-popup-row"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>' + dealer.phone + '</div>' : '';
    var address = dealer.address ? '<div class="dm-popup-row"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' + dealer.address + '</div>' : '';
    var dirUrl  = getDirectionsUrl(dealer);
    var websiteBtn = dealer.url ? '<a href="' + dealer.url + '" target="_blank" rel="noopener" class="dm-popup-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>Website</a>' : '';
    var phoneBtn  = dealer.phone ? '<a href="tel:' + dealer.phone + '" class="dm-popup-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>Call</a>' : '';

    return [
      '<div class="dm-popup-inner">',
        '<div class="dm-popup-name">' + (dealer.name || 'Dealer') + '</div>',
        dealer.services ? '<div class="dm-popup-category">' + dealer.services + '</div>' : '',
        address,
        phone,
        '<div class="dm-popup-divider"></div>',
        '<div class="dm-popup-actions">',
          '<a href="' + dirUrl + '" target="_blank" rel="noopener" class="dm-popup-btn">',
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
            'Directions',
          '</a>',
          websiteBtn,
          phoneBtn,
        '</div>',
      '</div>'
    ].join('');
  }

  /* ── Left panel card HTML ── */
  function buildCardHTML(dealer) {
    var dirUrl = getDirectionsUrl(dealer);
    return [
      '<div class="dm-card-top">',
        '<div class="dm-card-name">' + (dealer.name || 'Dealer') + '</div>',
        dealer.tier === 'gold' ? '<span class="dm-card-badge">GOLD</span>' : '',
      '</div>',
      dealer.services ? '<div class="dm-card-category">' + dealer.services + '</div>' : '',
      dealer.address  ? '<div class="dm-card-addr"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' + dealer.address + '</div>' : '',
      '<div class="dm-card-actions">',
        '<a href="' + dirUrl + '" target="_blank" rel="noopener" class="dm-card-btn" onclick="event.stopPropagation()">',
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
          'Directions',
        '</a>',
        dealer.url   ? '<a href="' + dealer.url + '" target="_blank" rel="noopener" class="dm-card-btn" onclick="event.stopPropagation()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>Website</a>' : '',
        dealer.phone ? '<a href="tel:' + dealer.phone + '" class="dm-card-btn" onclick="event.stopPropagation()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>Call</a>' : '',
      '</div>'
    ].join('');
  }

  /* ── Main init ── */
  function initDealerMap(sid) {
    var config = window.dealerMapData && window.dealerMapData[sid];
    if (!config) return;

    var mapEl       = document.getElementById('dm-map-' + sid);
    var listEl      = document.getElementById('dm-list-' + sid);
    var searchInput = document.getElementById('dm-search-' + sid);

    if (!mapEl || !listEl || typeof L === 'undefined') return;

    /* 清理旧列表与地图实例，防重复初始化 */
    if (mapEl._leafletMap) { mapEl._leafletMap.remove(); delete mapEl._leafletMap; }
    listEl.innerHTML = '';

    var dealers     = config.dealers     || [];
    var defaultLat  = config.defaultLat  || 39.5;
    var defaultLng  = config.defaultLng  || -98.0;
    var defaultZoom = config.defaultZoom || 4;

    /* ── 解析经纬度：优先尝试从 mapLocation 中解析 ── */
    dealers.forEach(function (dealer) {
      if (dealer.mapLocation) {
        var parsed = parseCoords(dealer.mapLocation);
        if (parsed) {
          dealer.lat = parsed.lat;
          dealer.lng = parsed.lng;
        }
      }
    });

    /* ── Map init with OpenStreetMap ── */
    var map = L.map(mapEl, { zoomControl: false }).setView([defaultLat, defaultLng], defaultZoom);
    mapEl._leafletMap = map;

    /* Zoom control — bottom right */
    L.control.zoom({ position: 'bottomright' }).addTo(map);

    /* OpenStreetMap tiles */
    var tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    L.tileLayer(tileUrl, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);

    var markers   = [];
    var activeIdx = null;

    function activateDealer(idx) {
      var cur = markers[idx];
      if (!cur) return;

      /* 取消上一个激活状态 */
      if (activeIdx !== null && activeIdx !== idx) {
        var prev = markers[activeIdx];
        if (prev) {
          if (prev.marker) prev.marker.setIcon(makePinIcon(prev.dealer.tier, ''));
          if (prev.card)   prev.card.classList.remove('active');
        }
      }

      activeIdx = idx;

      if (cur.marker) {
        cur.marker.setIcon(makePinIcon(cur.dealer.tier, 'active'));
        cur.marker.openPopup();
        map.panTo([cur.dealer.lat, cur.dealer.lng]);
        map.invalidateSize();
      }

      if (cur.card) {
        cur.card.classList.add('active');
        cur.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function deactivateAll() {
      if (activeIdx !== null) {
        var prev = markers[activeIdx];
        if (prev) {
          if (prev.marker) { prev.marker.setIcon(makePinIcon(prev.dealer.tier, '')); prev.marker.closePopup(); }
          if (prev.card)   prev.card.classList.remove('active');
        }
        activeIdx = null;
      }
    }

    /* 暴露给 Theme Editor 联动 */
    mapEl._activateByBlockId = function (bid) {
      for (var k = 0; k < markers.length; k++) {
        if (markers[k].dealer && markers[k].dealer.blockId === bid) {
          activateDealer(k);
          break;
        }
      }
    };

    dealers.forEach(function (dealer, i) {
      /* Card */
      var card = document.createElement('div');
      card.className = 'dm-card';
      card.innerHTML = buildCardHTML(dealer);
      card.addEventListener('click', function () { activateDealer(i); });
      listEl.appendChild(card);

      /* Coord guard */
      var hasCoords = !isNaN(dealer.lat) && !isNaN(dealer.lng) &&
                      !(dealer.lat === 0 && dealer.lng === 0);

      if (!hasCoords) {
        markers.push({ marker: null, dealer: dealer, card: card });
        return;
      }

      /* Marker */
      var marker = L.marker([dealer.lat, dealer.lng], {
        icon: makePinIcon(dealer.tier, '')
      }).addTo(map);

      /* Popup */
      marker.bindPopup(buildPopupHTML(dealer), {
        className: 'dm-popup',
        maxWidth: 280,
        minWidth: 240
      });

      marker.on('mouseover', function () {
        if (activeIdx !== i) marker.setIcon(makePinIcon(dealer.tier, 'hovered'));
      });
      marker.on('mouseout', function () {
        if (activeIdx !== i) marker.setIcon(makePinIcon(dealer.tier, ''));
      });
      marker.on('click', function (e) {
        L.DomEvent.stopPropagation(e);
        activateDealer(i);
      });
      marker.on('popupclose', function () {
        if (activeIdx === i) {
          marker.setIcon(makePinIcon(dealer.tier, ''));
          if (card) card.classList.remove('active');
          activeIdx = null;
        }
      });

      markers.push({ marker: marker, dealer: dealer, card: card });
    });

    map.on('click', deactivateAll);

    /* Search */
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = this.value.toLowerCase().trim();
        markers.forEach(function (m) {
          var d = m.dealer;
          var match = !q
            || (d.name     && d.name.toLowerCase().includes(q))
            || (d.address  && d.address.toLowerCase().includes(q))
            || (d.services && d.services.toLowerCase().includes(q))
            || (d.bikes    && d.bikes.toLowerCase().includes(q));
          if (m.card)   m.card.style.display = match ? '' : 'none';
          if (m.marker) {
            if (match) { if (!map.hasLayer(m.marker)) m.marker.addTo(map); }
            else        { if (map.hasLayer(m.marker))  map.removeLayer(m.marker); }
          }
        });
      });
    }
  }

  /* ── Entry: wait for Leaflet ── */
  function waitAndInit() {
    if (typeof L === 'undefined') {
      waitAndInit._n = (waitAndInit._n || 0) + 1;
      if (waitAndInit._n < 50) setTimeout(waitAndInit, 100);
      return;
    }
    Object.keys(window.dealerMapData || {}).forEach(initDealerMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

  /* ── Shopify Theme Editor Support ── */
  document.addEventListener('shopify:section:load', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (sid) {
      initDealerMap(sid);
    } else {
      waitAndInit();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    var mapEl = document.getElementById('dm-map-' + sid);
    if (mapEl && mapEl._leafletMap) {
      mapEl._leafletMap.remove();
      delete mapEl._leafletMap;
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var bid = e.detail && e.detail.blockId;
    if (!bid) return;
    Object.keys(window.dealerMapData || {}).forEach(function (sid) {
      var mapEl = document.getElementById('dm-map-' + sid);
      if (mapEl && mapEl._activateByBlockId) {
        mapEl._activateByBlockId(bid);
      }
    });
  });
})();
